import api from './api';

export interface ResetDemoResult {
  scans: number;
  created: number;
  updated: number;
}

export async function resetDemoSeed(): Promise<ResetDemoResult> {
  const r = await api.post<{ success: boolean; data: ResetDemoResult }>('/api/v1/admin/reset-demo');
  return r.data.data;
}
